let posthogInstance = {}
let posthogCapture = () => {}

export function setPosthogInstance(instance, captureFn) {
  posthogInstance = instance
  posthogCapture = captureFn
}

export function usePosthog() {
  return {
    posthog: posthogInstance,
    capture: posthogCapture,
  }
}
